import * as React from 'react';
import LngLat = mapboxgl.LngLat;

export default (createPoint: IFunction, lngLat: LngLat) => {
  return (
    <input
      type="file"
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => createPoint(e, lngLat)}
    />
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/views/popUp/UploadPhotoView.tsx